import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
const ReportProblem = () => {
  const navigate = useNavigate();
  const [problemType, setProblemType] = useState('');
  const [description, setDescription] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const problemTypes = [{
    id: 'general',
    label: 'General Problem'
  }, {
    id: 'account',
    label: 'Account Related'
  }, {
    id: 'package',
    label: 'Package Related'
  }, {
    id: 'payment',
    label: 'Payment Related'
  }, {
    id: 'question',
    label: 'Question/Concern'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would submit the ticket
    alert('Ticket created!');
    navigate('/more');
  };
  const selectProblemType = (type: string, label: string) => {
    setProblemType(label);
    setShowDropdown(false);
  };
  return <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Icon in circle */}
      <div className="flex justify-center mt-8 mb-4">
        <div className="h-16 w-16 rounded-full bg-gray-700 dark:bg-gray-600 flex items-center justify-center">
          <FileText className="h-8 w-8 text-white" />
        </div>
      </div>
      <p className="text-center text-gray-600 dark:text-gray-400 mb-6">
        Tell us about your issue and we'll get back to you
      </p>
      {/* Report Form */}
      <form onSubmit={handleSubmit} className="px-4">
        <div className="mb-6 relative">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Problem Type
          </label>
          <div className="relative">
            <button type="button" className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-left flex justify-between items-center text-gray-900 dark:text-white" onClick={() => setShowDropdown(!showDropdown)}>
              <span>{problemType || 'Select problem type'}</span>
              <svg className="h-5 w-5 text-gray-400 dark:text-gray-500" viewBox="0 0 20 20" fill="none" stroke="currentColor">
                <path d="M7 7l3 3 3-3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            {showDropdown && <div className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-800 shadow-lg rounded-md overflow-hidden border border-gray-300 dark:border-gray-600">
                {problemTypes.map(type => <button key={type.id} type="button" className={`w-full text-left px-4 py-2 hover:bg-blue-50 dark:hover:bg-blue-900/30 text-gray-900 dark:text-white ${type.label === problemType ? 'bg-blue-100 dark:bg-blue-900/50' : ''}`} onClick={() => selectProblemType(type.id, type.label)}>
                    {type.label}
                  </button>)}
              </div>}
          </div>
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Description
          </label>
          <textarea value={description} onChange={e => setDescription(e.target.value)} className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 h-40 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" placeholder="Describe your issue..." />
        </div>
        <button type="submit" className="w-full bg-orange-500 hover:bg-orange-600 dark:bg-orange-600 dark:hover:bg-orange-700 text-white font-medium py-3 px-4 rounded-md shadow-sm">
          CREATE TICKET
        </button>
      </form>
    </div>;
};
export default ReportProblem;